// BULK-CAP-1: one drop can hold 500 files. The server still takes 100 per session.
import { fileDisplayName } from "./collectDroppedFiles";

export const BULK_BATCH_SIZE = 100;
export const MAX_UPLOAD_TOTAL = 500;

export function dedupeQueued(files) {
  const seen = new Set();
  const kept = [];
  const skipped = [];
  const list = Array.isArray(files) ? files : Array.from(files || []);
  for (let i = 0; i < list.length; i += 1) {
    const file = list[i];
    const name = fileDisplayName(file);
    const key = `${name}\0${file && file.size}\0${file && file.lastModified}`;
    if (seen.has(key)) {
      skipped.push({ name, reason: "duplicate in this upload", file });
      continue;
    }
    seen.add(key);
    kept.push(file);
  }
  return { files: kept, skipped };
}

export function splitIntoBatches(files, size) {
  const list = Array.isArray(files) ? files : Array.from(files || []);
  const limit = size > 0 ? size : BULK_BATCH_SIZE;
  const batches = [];
  for (let i = 0; i < list.length; i += limit) batches.push(list.slice(i, i + limit));
  return batches;
}
